module.exports = __webpack_public_path__ + "static/media/CL.21be8529.svg";